// Theme options for form HTML code generation
export interface ThemeOption {
  value: string;
  label: string;
}

export const THEME_OPTIONS: ThemeOption[] = [
  { value: "default", label: "Default (Built-in CSS)" },
  { value: "bootstrap5", label: "Bootstrap 5" },
  { value: "tailwind", label: "Tailwind CSS" },
  { value: "none", label: "No Styling" },
];

export const DEFAULT_THEME = "default";
